import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import FilterResults from 'react-filter-search';
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, table, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  postMethod,
  validateMobile,
  singleParam,
  editUserGrid,
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import TextField from "@material-ui/core/TextField";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { WEB_BASE_URL } from "../../../../_services/constant";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const AddExhibitionSession = (props) => {
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const [branchEncryptID, setBranchEncryptID] = React.useState(localStorage.getItem("jwl_branchEncrypt_id"));
  const [copylink, setCopylink] = useState("");
  const [sharedLink, setSharedLink] = useState("");
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [productsValidation, setProductsValidation] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomers, setselectedCustomers] = useState([]);
  const [copyed, setCopyed] = useState(false);
  const [subcategory, setSubcategory] = useState([]);
  const [productlist, setproductlist] = useState([]);
  const [selectedSubCategory, setselectedSubCategory] = useState([]);
  const [selectedSubCategoryObject, setSelectedSubCategoryObject] = useState({
    mtran_id: "",
    category_id: "",
    subcategory_id: "",
    text: "",
    min_amount: null,
    max_amount: null
  });
  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id,
    entry_no: "",
    title: "",
    customer_session_products: [],
    remarks: "",
  });
  const [success, setSuccess] = useState(false);

  const [entryDelete, setEntryDelete] = useState(false);
  const [isvalid, setIsValid] = useState({
    mobile: true,
    email: true,
  });
  const [valid, setValid] = useState({
    mobile: true,
    email: true,
  });

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        marginLeft: -10,
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 310,
      },
    },
  };

  const addData = () => {
    if (selectedSubCategory.length == 0) {
      setProductsValidation(true);
    }
    else {
      setLoadInsert(true);
      param.product_ids = selectedSubCategory;
      param.customers = [];
      postMethod("api/transactions/customer/exhibition/insert", param).then((data) => {
        if (data.status === 200) {
          setParam({ ...param, tran_id: data.ID });
          toggle();
          setLoadInsert(false);
        }
        else {
          setLoadInsert(false);
        }
      });
    }

  };

   const SearchProduct = () => {
      // console.log("shivam",JSON.stringify(selectedSubCategoryObject));
      if (selectedSubCategoryObject.subcategory_id !== "") {
        postMethod("api/transactions/customer/session/getProducts", 
        {
          subcategory_id: selectedSubCategoryObject.subcategory_id, 
          category_id: selectedSubCategoryObject.category_id,     
          min_amount: selectedSubCategoryObject.min_amount,
          max_amount: selectedSubCategoryObject.max_amount
        }).then((data) => {
          setproductlist(data.data);
        });
        
      }
    };


  useEffect(() => {
    setCopylink(WEB_BASE_URL + "e?t=" + branchEncryptID)
    setSharedLink(WEB_BASE_URL + "e?t=" + branchEncryptID);
    var selectCategory = [];
    postMethod("api/transactions/customer/session/getSubcategory", {}).then((data) => {
      setSubcategory(data.data);
      selectCategory = data.data;
    });
    setLoad(true);
    if (id !== null) {

      var temp = window.atob(id);
      postMethod("api/transactions/customer/exhibitionsession/preview-session", { tran_id: temp }).then((dataD) => {
        var data = dataD.data[0];
        setParam({
          ...param,
          tran_id: temp,
          entry_no: data.entry_no,
          title: data.title,
          customer_session_products: data.products,
          remarks: data.remarks,
        }
        );
        setselectedSubCategory(data.products);

        let newselectedCategoryArr = [...data.products]
        for (let Mainindex = 0; Mainindex < selectCategory.length; Mainindex++) {
          const elementMain = selectCategory[Mainindex];

          for (let logoindex = 0; logoindex < newselectedCategoryArr.length; logoindex++) {
            const element = newselectedCategoryArr[logoindex];
            if (element.subcategory_id === elementMain.subcategory_id) {
              selectCategory[Mainindex].checked = 'true';
            }
          }
        }
        setSubcategory([...selectCategory]);
        setselectedCustomers(data.customers);

        setLoad(false);
      });
    }
    else {
      postMethod("api/transactions/customer/exhibitionsession/preview-session", { tran_id: 0 }).then((dataD) => {
        var data = dataD.data[0];
        setParam({
          ...param,
          entry_no: data.entry_no
        });
        setselectedSubCategory(data.products);

        let newselectedCategoryArr = [...data.products]
        for (let Mainindex = 0; Mainindex < selectCategory.length; Mainindex++) {
          const elementMain = selectCategory[Mainindex];

          for (let logoindex = 0; logoindex < newselectedCategoryArr.length; logoindex++) {
            const element = newselectedCategoryArr[logoindex];
            if (element.subcategory_id === elementMain.subcategory_id) {
              selectCategory[Mainindex].checked = 'true';
            }
          }
        }
        setSubcategory([...selectCategory]);
        setLoad(false);
      });
    }

    postMethod("api/transactions/customer/customerListMob", {}).then((data) => {
      setCustomerList(data.data);
      Setsearchable({ ...searchable, data: data.data });
    });

  }, []);

  // check object is null or undefined
  const checkObject = (obj) => {
    return obj === undefined ? {} : Object.keys(obj).length === 0 && obj.constructor === Object;
  };
  // Add single product
  const AddProduct = (Obj) => {
    var tempIndex = selectedSubCategory.findIndex(x => x.product_id === Obj.product_id);
    var tempArry = [...selectedSubCategory];
    if (tempIndex > -1) {
      tempArry.splice(tempIndex, 1);
      setselectedSubCategory(tempArry);
    }
    else {
      var tempparam = {
        mtran_id: param.tran_id,
        category_id: Obj.category_id,
        subcategory_id: Obj.subcategory_id,
        product_id: Obj.product_id,
        product_code: Obj.product_code,
        product_name: Obj.product_name,
        gender: Obj.gender,
        price: Obj.price,
        color: Obj.color,
        size_length: Obj.size_length,
        url_image: Obj.url_image,
        image_path: Obj.image_path,
        isImageUrl: Obj.isImageUrl
      }
      tempArry.push(tempparam);
      setselectedSubCategory(tempArry);
    }
  };

  // Add Or Remove ALL Product from arry
  const AddAllProduct = (checkAll) => {
    var tempArry = [...selectedSubCategory];
    if (checkAll) {
      productlist.forEach(Obj => {
        var tempIndex = tempArry.findIndex(x => x.product_id === Obj.product_id);
        if (tempIndex == -1) {
          var tempparam = {
            mtran_id: param.tran_id,
            category_id: Obj.category_id,
            subcategory_id: Obj.subcategory_id,
            product_id: Obj.product_id,
            product_code: Obj.product_code,
            product_name: Obj.product_name,
            gender: Obj.gender,
            price: Obj.price,
            color: Obj.color,
            size_length: Obj.size_length,
            url_image: Obj.url_image,
            image_path: Obj.image_path,
            isImageUrl: Obj.isImageUrl
          }
          tempArry.push(tempparam);
        }
      });
    }
    else {
      productlist.forEach(Obj => {
        //  var tempIndex = tempArry.findIndex(x => x.customer_id === Obj.customer_id);   
        var tempIndex = tempArry.findIndex(x => x.product_id === Obj.product_id);
        if (tempIndex > -1) {
          tempArry.splice(tempIndex, 1);
        }
      });
    }

    setselectedSubCategory(tempArry);
  };


  const removeProduct = (i) => {
    let tempArry = [...selectedSubCategory];
    tempArry.splice(i, 1);
    setselectedSubCategory(tempArry);
  };

  const removeProductAll = () => {
    if (window.confirm("Are you sure want to remove all products ?")) {
      setselectedSubCategory([]);
    }
  }
  const {
    buttonLabel,
    className
  } = props;


  // Link Modal Toggle
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  // Customer Modal Toggle
  const [customerModal, setCustomerModal] = useState(false);
  const toggleCustomerModal = () => setCustomerModal(!customerModal);


  // Add Or Remove single Customer from arry
  const AddCustomer = (Obj) => {
    var tempIndex = selectedCustomers.findIndex(x => x.customer_id === Obj.customer_id);
    var tempArry = [...selectedCustomers];
    if (tempIndex > -1) {
      tempArry.splice(tempIndex, 1);
      setselectedCustomers(tempArry);
    }
    else {
      var tempparam = {
        mtran_id: param.tran_id,
        customer_id: Obj.customer_id,
        full_name: Obj.full_name,
        mobile: Obj.mobile
      }
      tempArry.push(tempparam);
      setselectedCustomers(tempArry);
    }
  };


  // Add Or Remove ALL Customer from arry
  const AddAllCustomer = (checkAll) => {
    var tempArry = [...selectedCustomers];
    if (checkAll) {
      customerList.forEach(Obj => {
        var tempIndex = tempArry.findIndex(x => x.customer_id === Obj.customer_id);
        if (tempIndex == -1) {
          var tempparam = {
            mtran_id: param.tran_id,
            customer_id: Obj.customer_id,
            full_name: Obj.full_name,
            mobile: Obj.mobile
          }
          tempArry.push(tempparam);
        }
      });
    }
    else {
      customerList.forEach(Obj => {
        var tempIndex = tempArry.findIndex(x => x.customer_id === Obj.customer_id);
        if (tempIndex > -1) {
          tempArry.splice(tempIndex, 1);
        }
      });
    }

    setselectedCustomers(tempArry);
  };

  // Send SMS To Customers
  const sendSMS = () => {

    var paramD = {
      tran_id: 0,
      mtran_id: param.tran_id,
      sms: "exhibition session sms",
      type: "exhibition session",
      sms_details: selectedCustomers,
      shared_url: "e?t=" + branchEncryptID,
    };
    postMethod("api/transactions/customer/exhibitionsession/SendSms", paramD).then((dataD) => {
      props.history.push("/branch/customer/exhibition-session");
    });
  }


  const [searchable, Setsearchable] = useState({
    data: customerList,
    value: ''
  })
  const handleSeachChange = event => {
    Setsearchable({ ...searchable, value: event.target.value });
  };

  const dateConvert = (date) => {
    const originalDate = new Date(date);

    const year = originalDate.getFullYear();
    const month = String(originalDate.getMonth() + 1).padStart(2, '0');
    const day = String(originalDate.getDate()).padStart(2, '0');
    const hours = String(originalDate.getHours()).padStart(2, '0');
    const minutes = String(originalDate.getMinutes()).padStart(2, '0');
    const seconds = String(originalDate.getSeconds()).padStart(2, '0');
    const ampm = originalDate.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return formattedDate

  }
  return (
    <>

      <div>

        <Modal isOpen={customerModal} toggle={toggleCustomerModal} className={`${className || ""} exhibition-session-customer-modal`} zIndex="999999">
          <ModalHeader toggle={toggleCustomerModal}>
            <div className="exhibition-session-modal-title">
              <span className="exhibition-session-modal-icon">
                <i className="fa fa-users"></i>
              </span>
              <div>
                <h4>Customer List</h4>
                <p>Select customers to share this exhibition session.</p>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="exhibition-session-modal-body">
            <Row>
              <Col sm={12}>
                <div className="exhibition-session-customer-toolbar">
                  <div className="exhibition-session-customer-search">
                    <i className="fa fa-search"></i>
                    <input
                      type="text"
                      placeholder="Search customer"
                      value={searchable.value}
                      onChange={(e) => handleSeachChange(e)}
                    />
                  </div>
                </div>

                <div className="exhibition-session-customer-table-wrap">
                  <table className="table table-bordered exhibition-session-customer-table">
                    <thead>
                      <tr>
                        <th>
                          <div className="exhibition-session-customer-all">
                            ALL{" "}
                            {!searchable.value && (
                              <input
                                type="checkbox"
                                className="exhibition-session-customer-check"
                                name="available"
                                onChange={(e) => {
                                  AddAllCustomer(e.target.checked);
                                }}
                              />
                            )}
                          </div>
                        </th>
                        <th>Customer Name</th>
                        <th>Mobile</th>
                        <th>Category</th>
                        <th>Join Date</th>
                        <th>Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <FilterResults
                        value={searchable.value}
                        data={searchable.data}
                        renderResults={(results) =>
                          results.length > 0
                            ? results.map((obj, i) => {
                              return (
                                <tr key={i}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedCustomers.findIndex(
                                          (e) => e.customer_id === obj.customer_id
                                        ) > -1
                                      }
                                      className="exhibition-session-customer-check"
                                      name="available"
                                      onChange={() => {
                                        AddCustomer(obj);
                                      }}
                                    />
                                  </td>
                                  <td>{i + 1} {obj.full_name}</td>
                                  <td>{obj.mobile}</td>
                                  <td>{obj.category_name}</td>
                                  <td>{dateConvert(obj.datetime)}</td>
                                  <td>{obj.type}</td>
                                </tr>
                              );
                            })
                            : null
                        }
                      />
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="exhibition-session-modal-footer">
            <Button color="primary" className="exhibition-session-modal-action" onClick={() => { sendSMS(); }}>Send</Button>{' '}
            <Button color="primary" className="exhibition-session-modal-action" onClick={() => { props.history.push("/branch/customer/exhibition-session") }}>Back to Browse</Button>{' '}
            <Button color="secondary" className="exhibition-session-modal-cancel" onClick={toggleCustomerModal}>Cancel</Button>
          </ModalFooter>
        </Modal>



        <Modal isOpen={modal} toggle={toggle} backdrop="static" className={className} zIndex="999999">
          <ModalHeader toggle={toggle}>Customer Link</ModalHeader>
          <ModalBody>
            <div className="d-flex w-100"> <div style={{ background: "rgb(190 196 231)", padding: "16px" }} >
              {copylink}
            </div>

              <CopyToClipboard text={copylink}
                onCopy={() => { }}>
                {copyed ? <i className="fas fa-copy" style={{ color: '#4dd74d', cursor: "pointer", padding: "16px" }}></i> : <i className="fas fa-copy" style={{ cursor: "pointer", padding: "16px" }} onClick={() => {
                  setCopyed(true);
                }}></i>}
              </CopyToClipboard>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => { toggle(); toggleCustomerModal(); }}>Share with Customer</Button>{' '}
            <Button color="primary" onClick={() => { props.history.push("/branch/customer/exhibition-session") }}>Back to Browse</Button>{' '}
          </ModalFooter>
        </Modal>

      </div>


      {load ? <Loader /> : null}
      <Form className="exhibition-session-editor-form" onSubmit={handleSubmit(addData)}>
        <div className="card card-custom gutter-b exhibition-session-editor-card">
          <div className="card-header exhibition-session-editor-header">
            <div className="card-title exhibition-session-editor-title">
              <span className="exhibition-session-editor-icon">
                <i className="fa fa-gem"></i>
              </span>
              <div>
                <h3 className="card-label">{id ? "Edit Exhibition Session" : "Add Customer Exhibition Session"}</h3>
                <p>Create an exhibition session, choose products, and share the exhibition link.</p>
              </div>
            </div>
          </div>
          <div className="card-body exhibition-session-editor-body">
            <Row className="exhibition-session-editor-grid">
              <Col sm={4}>
                <FormGroup>
                  <Label>Entry No.</Label>
                  <input
                    type="text"
                    required
                    value={param.entry_no}
                    disabled="true"
                    className="form-control h-auto py-2 px-6"
                    name="entry_no"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        entry_no: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>
              <Col sm={4}>
                <FormGroup>
                  <Label>Title</Label>
                  <input
                    type="text"
                    required
                    value={param.title}
                    className="form-control h-auto py-2 px-6"
                    name="title"
                    onChange={(e) =>
                      setParam({
                        ...param,
                        title: e.target.value,
                      })
                    }
                    ref={register}
                  />
                </FormGroup>
              </Col>


              <Col sm={4}>
                <FormGroup>
                  <Label>Remarks</Label>
                  <textarea
                    value={param.remarks}
                    className="form-control h-auto py-2 px-6"
                    name="remarks"
                    onChange={(e) => setParam({ ...param, remarks: e.target.value })}
                    ref={register}
                  />
                </FormGroup>
              </Col>

              <Col sm={12}>
                <div className="exhibition-session-editor-section-title">
                  <h4>Find Products</h4>
                </div>
                <div className="exhibition-session-editor-table-wrap">
                  <Table bordered className="exhibition-session-editor-table exhibition-session-editor-search-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Min Amount</th>
                        <th>Max Amount</th>
                        <th>Action</th>
                      </tr>
                      <tr>
                        <th>
                          <select
                            className="form-control h-auto py-2 px-6"
                            name="product"
                            value={selectedSubCategoryObject.product_id}
                            onChange={(e) => {

                              setSelectedSubCategoryObject({
                                ...selectedSubCategoryObject,
                                category_id: e.target.value.split('-')[0],
                                subcategory_id: e.target.value.split('-')[1],
                                text: e.target.options[e.target.selectedIndex].text,
                              })
                            }
                            }
                          >
                            <option value="">-select-</option>
                            {subcategory.length < 0
                              ? null
                              : subcategory.map((obj, i) => {
                                return (
                                  <option key={i} value={obj.category_id + "-" + obj.subcategory_id}>
                                    {obj.subcategory_name + "(" + obj.category_name + ")"}
                                  </option>
                                );
                              })}
                          </select>
                        </th>
                        <th>
                          <input
                            type="number"
                            className="form-control h-auto py-2 px-6"
                            name="min_amount"
                            onChange={(e) =>
                              setSelectedSubCategoryObject({
                                ...selectedSubCategoryObject,
                                min_amount: e.target.value,
                              })
                            }
                            value={selectedSubCategoryObject.min_amount}
                          />
                        </th>
                        <th>
                          <input
                            type="number"
                            className="form-control h-auto py-2 px-6"
                            name="max_amount"
                            onChange={(e) =>
                              setSelectedSubCategoryObject({
                                ...selectedSubCategoryObject,
                                max_amount: e.target.value,
                              })
                            }
                            value={selectedSubCategoryObject.max_amount}
                          />
                        </th>
                        <th>
                          <button type="button" className="btn btn-success exhibition-session-editor-inline-btn" onClick={() => { SearchProduct() }}>
                            Search
                          </button>
                        </th>
                      </tr>
                    </thead>
                  </Table>
                </div>
              </Col>

              {productlist.length > 0 ?

                <Col sm={12}>
                  <div className="exhibition-session-editor-section-title">
                    <h4>Select Products</h4>
                  </div>
                  <div className="exhibition-session-editor-table-wrap">
                    <Table bordered className="exhibition-session-editor-table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Product Code </th>
                          <th>Product Name</th>
                          <th>Gender</th>
                          <th>Size</th>
                          <th>Color</th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Image</th>
                          <th>Exhibtion</th>
                          <th>Trial</th>
                          <th>
                            ALL  <input
                              type="checkbox"
                              className="exhibition-session-editor-row-check ml-2"
                              name="available"
                              onChange={(e) => {
                                AddAllProduct(e.target.checked)
                              }}
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {productlist.length > 0 ? productlist.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {obj.product_code}
                              </td>
                              <td>{obj.product_name}</td>
                              <td>{obj.gender}</td>
                              <td>{obj.size_length}</td>
                              <td>{obj.color}</td>
                              <td>{obj.price}</td>
                              <td>{obj.balance_qty}</td>
                              <td>
                                {obj.isImageUrl ? (
                                  <img src={obj.image_path} width="36px" alt="" />
                                ) : (
                                  <img src={obj.url_image + obj.image_path} width="36px" alt="" />
                                )}
                              </td>
                              <td>{obj.exhibition ? <label className="text-success">Active</label> : <label className="text-danger">Deactive</label>}</td>
                              <td>{obj.trial ? <label className="text-success">Active</label> : <label className="text-danger">Deactive</label>}</td>

                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedSubCategory.findIndex(e => e.product_id === obj.product_id) > -1 ? true : false}
                                  className="exhibition-session-editor-row-check"
                                  name="available"
                                  onChange={(e) => {
                                    AddProduct(obj);
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        }) : null}
                      </tbody>
                    </Table>
                  </div>
                </Col>
                : null}


              <Col sm={12}>
                <div className="exhibition-session-editor-section-title">
                  <h4>Selected Products {productsValidation ? <label className="text-danger">*Required</label> : null}</h4>
                  <button type="button" className="exhibition-session-editor-remove-all-btn" onClick={() => removeProductAll()}>
                    Clear All
                  </button>
                </div>
                <div className="exhibition-session-editor-table-wrap">
                  <Table bordered className="exhibition-session-editor-table">
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Product Code </th>
                        <th>Product Name</th>
                        <th>Gender</th>
                        <th>Size</th>
                        <th>Color</th>
                        <th>Price</th>
                        <th>Qty</th>
                        <th>Image</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedSubCategory.length > 0
                        ? selectedSubCategory.map((obj, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                {obj.product_code}
                              </td>
                              <td>{obj.product_name}</td>
                              <td>{obj.gender}</td>
                              <td>{obj.size_length}</td>
                              <td>{obj.color}</td>
                              <td>{obj.price}</td>
                              <td>{obj.stock_qty}</td>
                              <td>
                                {obj.isImageUrl ? (
                                  <img src={obj.image_path} width="36px" alt="" />
                                ) : (
                                  <img src={obj.url_image + obj.image_path} width="36px" alt="" />
                                )}
                              </td>
                              <td>

                                <button type="button" className="exhibition-session-editor-remove-btn" onClick={() => removeProduct(i)}>
                                  x
                                </button>
                              </td>
                            </tr>
                          );
                        }) : <tr>
                          <th colSpan="5" className="text-center"> No record </th>
                        </tr>}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>




            {success ? <Alert color="success">Saved Successfully</Alert> : null}
            {entryDelete ? <Alert color="danger">Entry Deleted</Alert> : null}
          </div>
          <div className="card-footer text-right exhibition-session-editor-footer">
            {id && (
              <button type="button" onClick={toggle} className="btn btn-success exhibition-session-editor-action-btn">
                Session Link
              </button>

            )}
            <a href="/branch/customer/exhibition-session" className="btn btn-secondary exhibition-session-editor-cancel-btn">
              Cancel
            </a>


            {!id && (loadInser ?
              <button type="button" className="btn btn-primary exhibition-session-editor-action-btn">
                Saving..
              </button> : <button type="submit" className="btn btn-primary exhibition-session-editor-action-btn">
                Save
              </button>)}
          </div>
        </div>
      </Form>
    </>
  );
};

export default AddExhibitionSession;
